import { useMemo, useState } from "react";
import { List, UsersThree, Robot } from "@phosphor-icons/react";
import { TgAvatar } from "./TgMensaje";
import { horaCorta, resumenUltimo } from "../../lib/telegram";

const CARPETAS = [["all", "Todos"], ["groups", "Grupos"], ["personal", "Personales"], ["bots", "Bots"]];

/** Lista de chats calcada de Telegram Web «A» (referencia real del Founder): tarjeta blanca, ☰ + buscador, pestañas
 * de carpeta en píldora, filas con avatar grande. variante: «tg» (módulo/burbuja/pantalla aparte, todas iguales),
 * «chips» (ancla, panel angosto: una fila de chips en vez de tarjeta -- no entra la lista completa ahí).
 * `menu`: lo propio de Commandix (separar en ventana, cerrar sesión, tema) -- vive detrás del ☰, como en Telegram Web. */
export default function TgLista({ chats, owner, activa, onElegir, variante = "tg", conteos, total, aviso, carpeta: carpetaExt, onCarpeta, menu }) {
  const [carpetaLocal, setCarpetaLocal] = useState("all");
  const carpeta = carpetaExt !== undefined ? carpetaExt : carpetaLocal;
  const elegirCarpeta = onCarpeta || setCarpetaLocal;
  const [q, setQ] = useState("");
  const [menuAbierto, setMenuAbierto] = useState(false);
  const visibles = useMemo(() => {
    const t = q.trim().toLowerCase();
    return chats.filter((c) => (carpeta === "all" || c.folder === carpeta) && (!t || (c.title || "").toLowerCase().includes(t)));
  }, [chats, carpeta, q]);

  if (variante === "chips") {
    return (
      <div className="tg-chips" data-testid="tg-lista" role="tablist">
        {chats.map((c) => (
          <button type="button" key={c.chat_id} role="tab" aria-selected={activa === c.chat_id} className={`tg-chip${activa === c.chat_id ? " on" : ""}`} data-testid="tg-chat-item" onClick={() => onElegir(c.chat_id)}>
            {c.locked ? "🔒 " : ""}{c.title}{!c.locked && c.unread > 0 ? <span className="tg-bd">{c.unread}</span> : null}
          </button>
        ))}
      </div>
    );
  }
  return (
    <div className={`tg-lista tg-${variante}`} data-testid="tg-lista">
      <div className="tg-busca">
        {menu && <button type="button" className="tg-ham" aria-label="Menú" aria-expanded={menuAbierto} data-testid="tg-rail-menu" onClick={() => setMenuAbierto((v) => !v)}><List size={18} weight="bold" /></button>}
        <input className="tg-in" type="search" placeholder="Buscar" aria-label="Buscar chat" data-testid="tg-buscar" value={q} onChange={(e) => setQ(e.target.value)} />
        {menu && <div className={`tg-menu-panel tg-menu-ham${menuAbierto ? " abierto" : ""}`} data-testid="tg-rail-menu-panel">{menu}</div>}
      </div>
      {onCarpeta && (
        <div className="tg-fo-pills" role="tablist">
          {CARPETAS.map(([k, label]) => (
            <button type="button" key={k} role="tab" aria-selected={carpeta === k} className={`tg-fpill${carpeta === k ? " on" : ""}`} data-testid={`tg-carpeta-${k}`} onClick={() => elegirCarpeta(k)}>
              {label}{conteos && conteos[k] ? <span className="tg-fpill-bd">{conteos[k]}</span> : null}
            </button>
          ))}
        </div>
      )}
      {aviso && <div className="tg-aviso-lista">{aviso}</div>}
      <div className="tg-items">
        {visibles.map((c) => {
          const propio = !c.locked && c.last && c.last.out;
          return (
            <button type="button" key={c.chat_id} className={`tg-ci${activa === c.chat_id ? " on" : ""}`} data-testid="tg-chat-item" data-chat={c.chat_id} onClick={() => onElegir(c.chat_id)}>
              <TgAvatar chat={c} owner={owner} tam={54} />
              <span className="tg-ci-t">
                <b>{c.folder === "groups" ? <UsersThree size={13} weight="fill" className="tg-ci-ico" aria-hidden="true" /> : c.folder === "bots" ? <Robot size={13} weight="fill" className="tg-ci-ico" aria-hidden="true" /> : null}{c.title}</b>
                <small>{c.locked ? "Con clave · nadie más lo ve" : <>{propio && <span className="tg-ci-tu">Tú: </span>}{resumenUltimo(c.last)}</>}</small>
              </span>
              <span className="tg-ci-r">
                {c.last && !c.locked ? <span className="tg-hora">{propio && <span className="tg-visto">✓✓ </span>}{horaCorta(c.last.ts)}</span> : null}
                {!c.locked && c.unread > 0 ? <span className="tg-bd tg-bd-v">{c.unread}</span> : null}
              </span>
            </button>
          );
        })}
        {!visibles.length && <div className="tg-vacio-l" data-testid="tg-lista-vacia">{chats.length ? "Ningún chat coincide." : "No hay chats para mostrar."}</div>}
        {total > chats.length && <div className="tg-aviso-lista" data-testid="tg-lista-parcial">Se muestran los primeros {chats.length} de {total} chats; buscar filtra solo entre esos.</div>}
      </div>
    </div>
  );
}
